import { render, staticRenderFns } from "./segmentationFixConfirmPopup.vue?vue&type=template&id=06a7bc59&scoped=true"
import script from "./segmentationFixConfirmPopup.vue?vue&type=script&lang=js"
export * from "./segmentationFixConfirmPopup.vue?vue&type=script&lang=js"
import style0 from "./segmentationFixConfirmPopup.vue?vue&type=style&index=0&id=06a7bc59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7bc59",
  null
  
)

export default component.exports